// src/components/Shared/RecipeCards/SplitActionButton.tsx
import React from 'react';
import { FaRegCalendarPlus } from 'react-icons/fa';
import { BsBookmarkFill, BsBookmark } from 'react-icons/bs';

interface SplitActionButtonProps {
  /** called when user clicks “Bookmark” */
  onToggleBookmark: () => void;
  /** true if this recipe is already bookmarked */
  isBookmarked: boolean;
  /** called when user clicks “Add to Meal Plan” */
  onAddToMealPlan: () => void;
  variant?: 'default' | 'search';
}

const SplitActionButton: React.FC<SplitActionButtonProps> = ({
  onToggleBookmark,
  isBookmarked,
  onAddToMealPlan,
  variant = 'default',
}) => {
  const isSearch = variant === 'search';

  return (
    <div
      className={`
        inline-flex overflow-hidden
        ${isSearch ? 'rounded-tl-lg' : 'rounded-full'}
      `}
    >
      {/* LEFT HALF: Bookmark */}
      <button
        onClick={onToggleBookmark}
        className={`
          flex items-center gap-1 px-3 py-2 text-sm font-medium border-l border-t border-b border-gray-300
          ${isSearch ? 'rounded-tl-lg' : 'rounded-l-full'}
          ${
            isBookmarked
              ? 'bg-green-100 text-green-700 hover:bg-green-200'
              : 'bg-white text-green-600 hover:bg-green-50'
          }
        `}
      >
        {isBookmarked ? (
          <BsBookmarkFill className="w-4 h-4" />
        ) : (
          <BsBookmark className="w-4 h-4" />
        )}
      </button>

      <div className="w-px bg-gray-300" />

      <button
        onClick={onAddToMealPlan}
        className={`
          flex items-center gap-1 px-3 py-1 text-sm font-medium
          bg-black text-white hover:bg-gray-800
        `}
      >
        <FaRegCalendarPlus className="w-4 h-4" />
      </button>
    </div>
  );
};


export default SplitActionButton;
